import React, { useState } from 'react';
import { useLocalize } from 'localize-react';
import { HubType, JourneyStatusType } from '@transferz/fe-models';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Card } from '@transferz/fe-component-library/src/components/card/Card';
import Typography from '@transferz/fe-component-library/src/components/typography/Typography';
import Calendar from '@transferz/fe-component-library/src/components/icons/CalendarIcon';
import Location from '@transferz/fe-component-library/src/components/icons/LocationIcon';
import PlaneTakeOff from '@transferz/fe-component-library/src/components/icons/PlaneTakeOffIcon';
import PlaneLanding from '@transferz/fe-component-library/src/components/icons/PlaneLandingIcon';
import PlaneTop from '@transferz/fe-component-library/src/components/icons/PlaneTopIcon';
import { PlaneIcon } from '@transferz/fe-component-library/src/components/icons/PlaneIcon';
import { TrainIcon } from '@transferz/fe-component-library/src/components/icons/TrainIcon';
import { SeaportIcon } from '@transferz/fe-component-library/src/components/icons';
import Timer from '@transferz/fe-component-library/src/components/icons/TimerIcon';
import Clock from '@transferz/fe-component-library/src/components/icons/ClockIcon';
import { GeoDirection } from '../../../../components/geoDirection/GeoDirection';
import { ExtendedCard } from '../../../../components/card/ExtendedCard';
import { formatDate, getTimeZoneShortNameAndOffset, formatTime } from '../../../../utils/utils';
import './tripDetails.scss';

export const TripDetails: React.FunctionComponent<any> = ({ journey }) => {
  const { translate } = useLocalize();
  const flags = useFlags();
  const journeyIsNotPending = journey?.status !== JourneyStatusType.Pending;
  const [isCollapsed, setIsCollapsed] = useState(journeyIsNotPending);
  const [distanceDuration, setDistanceDuration] = useState({}) as any;
  const truncate = (str: any, max: any, suffix: any) => str.length < max ? str : `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))}${suffix}`;

  let meetingPointDesk = journey?.meetingPoint?.description ? truncate(journey?.meetingPoint?.description, 200, ' ... ') : '';
  const { journeyExecutionInfo } = journey;

  const onDistanceAndDurationResolved = (distance: any, duration: any) => {
    distanceDuration.distance = distance;
    distanceDuration.duration = duration;
    setDistanceDuration({ ...distanceDuration });
  };
  const isFAQPlanned = journey.status === JourneyStatusType.Planned
    || journey.status === JourneyStatusType.Confirmed
    || journey.status === JourneyStatusType.DriverArrived
    || journey.status === JourneyStatusType.DriverUnderway;
  const onCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const loacationIcon = (location: any, inbound: boolean) => {
    if (location?.hub) {
      if (location?.hubData?.hubType === HubType.Airport) {
        return inbound
          ? <PlaneTakeOff className="trip-icon trip-icon-plane" width="23" height="28" />
          : <PlaneLanding className="trip-icon trip-icon-plane" width="23" height="28" />;
      } else if (location?.hubData?.hubType === HubType.TrainStation) {
        return <TrainIcon className="trip-icon trip-icon-train" width="23" height="28" />;
      } else if (location?.hubData?.hubType === HubType.Seaport) {
        return <SeaportIcon className="trip-icon trip-icon-port" width="23" height="28" />;
      } else {
        return <Location className="trip-icon icon-location" />;
      }
    } else {
      return <Location className="trip-icon icon-location" />;
    }
  };

  return (
    <div className={`trip-details ${flags?.showNewDesign ? 'card-wrap' : ''} ${isFAQPlanned ? 'faq-planned' : ''}`}>
      {
        flags?.showNewDesign
          ? (<Card title={translate('booking_tripDetails')} collapsed={isCollapsed} onCollapse={onCollapse}>
            <div>
              {journeyIsNotPending && window.innerWidth < 768 && !isCollapsed && (
                <GeoDirection
                  key={journey?.inbound ? journey?.destinationLocation?.address?.formattedAddress : journey?.originLocation?.address?.formattedAddress}
                  origin={journey?.originLocation?.position}
                  destination={journey?.destinationLocation?.position}
                  position={journey?.originLocation?.position}
                  center={journey?.originLocation?.position}
                  onDistanceAndDurationResolved={(distance: any, duration: any) => onDistanceAndDurationResolved(distance, duration)}
                  name="geographicLocation"
                />
              )}
              {journeyIsNotPending && window.innerWidth > 768 && isCollapsed && (
                <GeoDirection
                  key={journey?.inbound ? journey?.destinationLocation?.address?.formattedAddress : journey?.originLocation?.address?.formattedAddress}
                  origin={journey?.originLocation?.position}
                  destination={journey?.destinationLocation?.position}
                  position={journey?.originLocation?.position}
                  center={journey?.originLocation?.position}
                  onDistanceAndDurationResolved={(distance: any, duration: any) => onDistanceAndDurationResolved(distance, duration)}
                  name="geographicLocation"
                />
              )}
              {!journeyIsNotPending && (
                <GeoDirection
                  key={journey?.inbound ? journey?.destinationLocation?.address?.formattedAddress : journey?.originLocation?.address?.formattedAddress}
                  origin={journey?.originLocation?.position}
                  destination={journey?.destinationLocation?.position}
                  position={journey?.originLocation?.position}
                  center={journey?.originLocation?.position}
                  onDistanceAndDurationResolved={(distance: any, duration: any) => onDistanceAndDurationResolved(distance, duration)}
                  name="geographicLocation"
                />
              )}
              <div className="pb-32 trip-info-item info-first">
                {loacationIcon(journey?.originLocation, journey?.inbound)}
                <Typography variant="body1">
                  {journey?.originLocation?.hub ? journey?.originLocation?.hubData?.autoCompleteName : journey?.originLocation?.address?.originalAddress}
                </Typography>
                {!journey?.originLocation?.hub && <Typography variant="body1" color="asphalt5">{journey?.originLocation?.address?.formattedAddress}</Typography>}
              </div>
              <div className="trip-info-item info-second">
                {loacationIcon(journey?.destinationLocation, journey?.inbound)}
                <Typography variant="body1">
                  {journey?.destinationLocation?.hub ? journey?.destinationLocation?.hubData?.autoCompleteName : journey?.destinationLocation?.address?.originalAddress}
                </Typography>
                {!journey?.destinationLocation?.hub && <Typography variant="body2" color="asphalt5">{journey?.destinationLocation?.address?.formattedAddress}</Typography>}
              </div>
            </div>
            <div className="trip-info-item trip-info-distance">
              <div className="date trip-info-distance-item">
                <Calendar className="icon-calendar" width="22" height="22" />
                <Typography variant="body1">{formatDate(journeyExecutionInfo?.pickupDate, 'DD-MM-YYYY')}</Typography>
              </div>
              <div className="time trip-info-distance-item">
                <Clock className="icon-clock" direction="right" width="20" height="20" />
                <Typography variant="body1">{formatTime(journeyExecutionInfo?.pickupDate, 'HH:mm')}</Typography>
                <Typography variant="body2" color="asphalt5">{`${translate('booking_localTime')} ${getTimeZoneShortNameAndOffset(journey?.journeyExecutionInfo?.pickupTimeZone)}`}</Typography>
              </div>
              <div className="duration trip-info-distance-item">
                <Timer className="icon-timer" direction="right" width="25" height="25" />
                {distanceDuration?.duration && <Typography variant="body1">{distanceDuration?.duration} ({distanceDuration?.distance})</Typography>}
              </div>
            </div>
            <div className="trip-info-item trip-info-number">
              {journey?.travellerInfo?.flightNumber
                && <div className="trip-info-number-item">
                  <PlaneIcon className="plain-icon" />
                  <Typography variant="body1"> {journey?.travellerInfo?.flightNumber}</Typography>
                </div>
              }
              {journey?.travellerInfo?.trainNumber && (
                <div className="trip-info-number-item">
                  <TrainIcon className="train-icon" />
                  <Typography variant="body1"> {journey?.travellerInfo?.trainNumber}</Typography>
                </div>
              )}
              {(!journey?.travellerInfo?.flightNumber && !journey?.travellerInfo?.trainNumber)
                && <div className="trip-info-number-item">
                  <PlaneIcon className="plain-icon" />
                  <Typography variant="body1"> {translate('booking_unknown')}</Typography>
                </div>
              }
            </div>
          </Card>)
          : (<ExtendedCard title={translate('booking_tripDetails')} isEditable={true}>
            <div className="trip-info">
              <div className="trip-info-item">
                <Calendar className="trip-icon icon-calendar" />
                <span className="date-time">
                  <span className="text-bold">
                    <span>{formatDate(journey?.journeyExecutionInfo?.pickupDate)}</span>
                    <span>{formatTime(journey?.journeyExecutionInfo?.pickupDate)} ${translate('booking_localTime')} {getTimeZoneShortNameAndOffset(journey?.journeyExecutionInfo?.pickupTimeZone)}</span>
                  </span>
                </span>
                {journey?.travellerInfo?.flightNumber && !journey?.inbound && (
                  <span className="flight-number">
                    <PlaneTop className="trip-icon icon-plane" /> {journey?.travellerInfo?.flightNumber}
                  </span>
                )}
                {journey?.travellerInfo?.flightNumber && journey?.inbound && (
                  <span className="flight-number">
                    <PlaneTop className="trip-icon icon-plane" /> {journey?.travellerInfo?.flightNumber}
                  </span>
                )}
              </div>
              <div className="trip-info-item info-first">
                {journey?.inbound ? <Location className="trip-icon icon-location" /> : <PlaneLanding className="trip-icon trip-icon-plane" width="23" height="28" />}
                <div className="text-bold">
                  {journey?.originLocation?.hub ? journey?.hub?.autoCompleteName : journey?.originLocation?.address?.originalAddress}
                </div>
                <div className="text-normal">{journey?.originLocation?.address?.formattedAddress}</div>
                <div className="trip-info-text">
                  {meetingPointDesk}
                  {journey?.meetingPoint?.description.length > 200
                    && (<a href="#moreMeetingInfo" className="show-more" >{translate('viewMore')}</a>)
                  }
                </div>
              </div>
              <div className="trip-info-item">
                {journey?.inbound ? <PlaneTakeOff className="trip-icon trip-icon-plane" width="23" height="28" /> : <Location className="trip-icon icon-location" />}
                <div className="text-bold">
                  {journey?.destinationLocation?.hub ? journey?.hub?.autoCompleteName : journey?.destinationLocation?.address?.originalAddress}
                </div>
                <div className="text-normal">{journey?.destinationLocation?.address?.formattedAddress}</div>
              </div>
              {distanceDuration?.duration && <div className="distance-duration">{translate('estimated')} {distanceDuration?.duration?.text} ({distanceDuration?.distance?.text})</div>}
            </div>
            <GeoDirection
              key={journey?.inbound ? journey?.destinationLocation?.address?.formattedAddress : journey?.originLocation?.address?.formattedAddress}
              origin={journey?.originLocation?.position}
              destination={journey?.destinationLocation?.position}
              position={journey?.originLocation?.position}
              center={journey?.originLocation?.position}
              onDistanceAndDurationResolved={(distance: any, duration: any) => onDistanceAndDurationResolved(distance, duration)}
              name="geographicLocation"
            />
          </ExtendedCard>
          )}
    </div>
  );
};
